<div class="status-details">
  <h2 *ngIf="status.value.id !== 0 || editMode">
    <span id="icon" class="material-icons-outlined">check_circle</span>
    <span class="title-details">{{ statusTitle | translate }}</span>
  </h2>

  <div *ngIf="status.value.id === 0 && !editMode" class="empty-details">
    <span class="material-icons-outlined">check_circle</span>
  </div>

  <div *ngIf="status.value.id !== 0 || editMode" class="status-info-container">
    <div *ngIf="status.value.id !== 0 && !editMode" class="status-info">
      <table>
        <tr>
          <td>
            <strong>{{ "statusDetails.nameLabel" | translate }}:</strong>
          </td>
          <td>{{ status.value.name }}</td>
        </tr>
        <tr>
          <td>
            <strong>{{ "statusDetails.colorLabel" | translate }}:</strong>
          </td>
          <td>
            <span
              [style.background-color]="status.value.color"
              class="color-preview"
            ></span>
            {{ status.value.color }}
          </td>
        </tr>
      </table>

      <div *ngIf="supervisor" class="btn">
        <button class="btn-edit" (click)="toggleEditMode()">
          <span class="material-icons-outlined">edit</span>
          {{ "statusDetails.editButton" | translate }}
        </button>
        <button class="btn-delete" (click)="deleteStatus()">
          <span class="material-icons-outlined">delete</span>
          {{ "statusDetails.deleteButton" | translate }}
        </button>
      </div>
      <messages
        class="message"
        [form]="statusForm"
        [messagesObserver]="messages"
        [showNonFieldKeys]="TRUE"
        [showFieldName]="TRUE"
        [showFieldKeys]="FALSE"
      ></messages>
    </div>

    <form [formGroup]="statusForm" *ngIf="editMode">
      <div class="form-group">
        <label for="name">{{ "statusDetails.nameLabel" | translate }}:</label>
        <input type="text" id="name" formControlName="name" />
        <messages
          class="msg"
          [form]="statusForm"
          [messagesObserver]="messages"
          fieldname="name"
        ></messages>
        <div class="color">
          <label for="color"
            >{{ "statusDetails.colorLabel" | translate }}:</label
          >
          <input type="color" id="color" formControlName="color" />
        </div>
      </div>
      <div class="action-buttons">
        <action-button
          class="btn-save"
          (actionEvent)="saveStatus($event)"
          label="{{ 'statusDetails.saveButton' | translate }}"
        >
          <span class="material-icons-outlined">save</span>
          {{ "statusDetails.saveButton" | translate }}
        </action-button>

        <button type="button" class="btn-cancel" (click)="toggleEditMode()">
          <span class="material-icons-outlined">cancel</span>
          {{ "statusDetails.cancelButton" | translate }}
        </button>
      </div>

      <messages
        class="message"
        [form]="statusForm"
        [messagesObserver]="messages"
        [showNonFieldKeys]="TRUE"
        [showFieldName]="TRUE"
        [showFieldKeys]="FALSE"
      ></messages>
    </form>
  </div>
</div>
